/* eslint-disable import/no-unresolved */
import { Modal } from 'antd';
import { PackingTypeSale } from 'enums/packingTypeSale';
import { formatFullDecimal } from 'utils/number';
import * as S from './TrolleyLimitModal.styled';

function getSaleTypeLabel(typeSale: PackingTypeSale, quantity: number): string {
  switch (typeSale) {
    case PackingTypeSale.Layer:
      return quantity === 1 ? 'Camada' : 'Camadas';
    case PackingTypeSale.Trolley:
      return quantity === 1 ? 'Carrinho' : 'Carrinhos';
    default:
      return quantity === 1 ? 'Embalagem' : 'Embalagens';
  }
}

interface TrolleyLimitModalProps {
  visible: boolean;
  totalUnits: number;
  quantityOrdered: number;
  selectedTypeSale: PackingTypeSale;
  unitsPerType: number;
  totalPrice: number;
  shippingFeeTotal?: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function TrolleyLimitModal({
  visible,
  totalUnits,
  quantityOrdered,
  selectedTypeSale,
  unitsPerType,
  totalPrice,
  shippingFeeTotal,
  onConfirm,
  onCancel,
}: TrolleyLimitModalProps) {
  const typeLabel = getSaleTypeLabel(selectedTypeSale, quantityOrdered);
  const totalWithShipping = totalPrice + (shippingFeeTotal ?? 0);
  const shouldDisplayShippingFee = Boolean(shippingFeeTotal && shippingFeeTotal > 0);

  const totalPedidoLine = `${quantityOrdered} ${typeLabel} × ${unitsPerType} = ${totalUnits} un.`;
  const quantidadeInformada = `${quantityOrdered} ${typeLabel}`;

  return (
    <Modal
      visible={visible}
      footer={null}
      closable={false}
      onCancel={onCancel}
      width={480}
      bodyStyle={{ padding: 0 }}
    >
      <S.HeaderRow>
        <S.WarningIcon />
        <S.Title>Atenção</S.Title>
      </S.HeaderRow>

      <S.Divider />

      <S.Message>
        Você está comprando{' '}
        <strong>
          mais de 1 carrinho ({totalUnits} unidades).
        </strong>{' '}
        Deseja Prosseguir?
      </S.Message>

      <S.SummarySection>
        <S.SummaryTitle>Resumo</S.SummaryTitle>

        <S.SummaryRow>
          <S.SummaryLabel>Quantidade informada</S.SummaryLabel>
          <span>{quantidadeInformada}</span>
        </S.SummaryRow>

        <S.SummaryRow>
          <S.SummaryLabel>Total do pedido</S.SummaryLabel>
          <S.SummaryValueHighlight>{totalPedidoLine}</S.SummaryValueHighlight>
        </S.SummaryRow>
        {shouldDisplayShippingFee && (
          <S.SummaryRow>
            <S.SummaryLabel>Total do frete</S.SummaryLabel>
            <S.SummaryValueHighlight>
              R$ {formatFullDecimal(shippingFeeTotal || 0)}
            </S.SummaryValueHighlight>
          </S.SummaryRow>
        )}
        <S.Divider />
        <S.SummaryRow>
          <S.SummaryLabel>Total da Compra</S.SummaryLabel>
          <S.SummaryValueSuccess>
            R$ {formatFullDecimal(totalWithShipping)}
          </S.SummaryValueSuccess>
        </S.SummaryRow>
      </S.SummarySection>

      <S.Divider />

      <S.ActionButtons>
        <S.CancelButton type="button" onClick={onCancel}>
          Cancelar
        </S.CancelButton>
        <S.ConfirmButton type="button" onClick={onConfirm}>
          Sim, comprar
        </S.ConfirmButton>
      </S.ActionButtons>
    </Modal>
  );
}
